<template>
  <b-modal id="address-modal" ref="modal" size="lg" :title="title" @show="setData" @hidden="resetModal"
           @ok="handleOk" ok-title="Save">
    <b-form @submit.stop.prevent="onSubmit" >
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <div class="form-row">
                <label class="col-md-3">Street</label>
                <div class="col-md-8 mb-3">
                  <b-form-input type="text" class="form-control" :state="isEmpty(input_data.street)" v-model="input_data.street" ></b-form-input>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Address Type</label>
                <div class="col-md-8 mb-3">
                  <v-select :options="options.address_types" v-model="input_data.address_type" :reduce="address_type=>address_type.id" label="name"></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Country</label>
                <div class="col-md-8 mb-3">
                  <v-select :options="options.country" v-model="input_data.country" :reduce="country=>country.id" label="name" @input="getState"></v-select> *
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">State</label>
                <div class="col-md-8 mb-3">
                  <v-select :options="options.state" v-model="input_data.state" :reduce="state=>state.id" label="name" @input="getCity"></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">City</label>
                <div class="col-md-8 mb-3">
                  <v-select :options="options.city" v-model="input_data.city" :reduce="city=>city.id" label="name" @input="getSubDistrict"></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Sub District</label>
                <div class="col-md-8 mb-3">
                  <v-select :options="options.sub_district" v-model="input_data.sub_district" :reduce="sub_district=>sub_district.id" label="name"></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Village</label>
                <div class="col-md-8 mb-3">
                  <b-form-input type="text" class="form-control" :state="isEmpty(input_data.village)" v-model="input_data.village" ></b-form-input>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Postal Code</label>
                <div class="col-md-8 mb-3">
                  <b-form-input type="number" class="form-control" :state="isEmpty(input_data.postal_code)" v-model="input_data.postal_code" ></b-form-input>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Phone Number</label>
                <div class="col-md-8 mb-3">
                  <b-form-input type="number" class="form-control" :state="isEmpty(input_data.phone)" v-model="input_data.phone" ></b-form-input>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Fax No</label>
                <div class="col-md-8 mb-3">
                  <b-form-input type="number" class="form-control" :state="isEmpty(input_data.fax_no)" v-model="input_data.fax_no" ></b-form-input>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Description</label>
                <div class="col-md-8 mb-3">
                  <b-form-textarea
                      id="description"
                      placeholder="Description"
                      rows="4"
                      v-model="input_data.description"
                  ></b-form-textarea>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Status</label>
                <div class="col-md-8 mb-3">
                  <b-form-radio-group
                      v-model="input_data.status"
                      :options="options.status"
                      plain
                      name="plain-inline-status"
                  ></b-form-radio-group>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Default</label>
                <div class="col-md-8 mb-3">
                  <b-form-radio-group
                      v-model="input_data.default"
                      :options="options.default"
                      plain
                      name="plain-inline-default"
                  ></b-form-radio-group>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Status change by employee</label>
                <div class="col-md-8 mb-3">
                  <b-form-checkbox
                      id="checkbox-1"
                      v-model="input_data.is_locked"
                      name="checkbox-1"
                      value="accepted"
                      unchecked-value="not_accepted"
                  >
                    Yes, Status change
                  </b-form-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import {BForm, BFormGroup, BFormInput, BButton, BModal, BFormTextarea, BFormRadioGroup, BFormCheckbox} from "bootstrap-vue"

import vSelect  from "vue-select"
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";
export default {
  name: "AddressInput",
  components:{
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BModal,
    BFormTextarea,
    BFormRadioGroup,
    BFormCheckbox,
    vSelect
  },
  data(){
    return {
      title:"Add",
      input_data:{
        street:"",
        address_type:"",
        country:"",
        state:"",
        city:"",
        sub_district:"",
        village:"",
        phone:"",
        postal_code:"",
        fax_no:"",
        description:"",
        status:"active",
        default:false,
        is_locked:"accepted"
      },
      options:{
        address_types:[],
        country:[],
        state:[],
        city:[],
        sub_district:[],
        status:[{text:"Active", value:"active"}, { text:"Non Active", value:"non_active"}],
        default:[{text:"Yes", value:true}, { text:"No", value:false}],
      },
      config:{
        altFormat: 'M j, Y',
        altInput: true,
        dateFormat: 'Y-m-d',
        locale: {
          rangeSeparator: ' - '
        },
      },
    }
  },
  props:{
    data:{
      type:Object
    }
  },
  computed:{
    country(){
      return this.input_data.country
    },
    state(){
      return this.input_data.state
    },
    city(){
      return this.input_data.city
    }
  },
  watch:{
     country(){
       if(this.input_data.country) this.getState()
    },
    state(){
      if(this.input_data.state) this.getCity()
    },
    city(){
       if(this.input_data.city !== null) this.getSubDistrict()
    }
  },
  methods:{
    isEmpty(val){
      return val !== ""
    },
    onSubmit(){
      if (!this.checkForm()){
        this.$parent.errorMessage("Please fill out required field")
        return
      }
      let payload = {
        emp_id:this.$store.getters.empId,
        addr_addrtype_id:this.input_data.address_type,
        addr_street:this.input_data.street,
        addr_country_id:this.input_data.country,
        addr_state_id:this.input_data.state == "" ? null : this.input_data.state,
        addr_city_id:(this.input_data.city == "" ? null :this.input_data.city),
        addr_subdistrict_id:(this.input_data.sub_district === "" ? null: this.input_data.sub_district),
        addr_village:this.input_data.village,
        addr_postal_code:this.input_data.postal_code,
        addr_phone:this.input_data.phone,
        addr_fax:this.input_data.fax_no,
        addr_status:(this.input_data.status == 'active' ? 1:0),
        addr_desc:this.input_data.description,
        user_id:this.$store.getters.userId
      }

      if (this.data !== null){
        payload.id = this.data.id
        AxiosCall.Put(payload, urlApi.address.update).then(res=>{
          if(res.success){
            this.$parent.successMessage(res.message)
            this.$refs.modal.hide()
            this.$parent.getData()
          }else {
            this.$parent.errorMessage(res.message)
          }
        }).catch(e=>{
          this.$parent.errorMessage(e.response.data.message)
        })
      }else{
        AxiosCall.Post(payload, urlApi.address.add).then(res=>{
          if(res.success){
            this.$parent.successMessage(res.message)
            this.$refs.modal.hide()
            this.$parent.getData()
          }else {
            this.$parent.errorMessage(res.message)
          }
        }).catch(e=>{
          this.errorMessage(e.response.data.message)
        })
      }
    },
    handleOk(bvModalEvt){
      bvModalEvt.preventDefault()
      this.onSubmit()
    },
    resetModal(){
      this.title = "Add"
      this.$parent.data = null
      this.input_data = {
        street:"",
        address_type:"",
        country:"",
        state:"",
        city:"",
        sub_district:"",
        village:"",
        phone:"",
        postal_code:"",
        fax_no:"",
        description:"",
        status:"active",
        default:false,
        is_locked:"accepted"
      }
    },
    getCountry(){
      let payload = {}
      AxiosCall.Get(payload, urlApi.country.list).then(res=>{
        if (res.success){
          this.options.country = res.atributes
        }else{
          this.$parent.errorMessage(res.message)
        }
      }).catch(e=>{
        this.$parent.errorMessage(e.response.data.message)
      })
    },
    getTypeAddress(){
      let payload = {

      }
      AxiosCall.Get(payload, urlApi.address.type).then(res=>{
        if(res.success){
          this.options.address_types = res.atributes
        }else{
          this.$parent.errorMessage(res.message)
        }
      }).catch(e=>{
        this.$parent.errorMessage(e.response.data.message)
      })

    },
    setData(){
      setTimeout(()=>{
        if (this.data !== null){
          this.title = "Edit"
          this.input_data = {
            street:this.data.street,
            address_type:this.data.type_id,
            country:this.data.country,
            state:this.data.state,
            city:this.data.city,
            sub_district:this.data.sub_district,
            village:this.data.village,
            phone:this.data.phone_number,
            postal_code:this.data.postal_code,
            fax_no:this.data.fax_number,
            description:this.data.desc,
            status:(this.data.status == 1) ? 'active':'not_active',
            default:(this.data.is_default == 1) ? true:false,
            is_locked:"accepted"
          }
        }
      }, 100)
    },
    getState(){
      this.options.state = []
      this.input_data.state = ""

      if(this.input_data.country !== null){
        let payload = {
          country_id:this.input_data.country
        }
        AxiosCall.Get(payload, urlApi.state.combo).then(res=>{
          if(res.success){
            this.options.state = res.atributes
            if(this.data !== null){
              let found = this.options.state.some(el => el.id == this.data.state);
              this.input_data.state=(found ? this.data.state : "" )
            }
          }else {
            this.$parent.errorMessage(res.atributes)
          }
        }).catch(e=>{
          this.$parent.errorMessage(e.response.data.message)
        })
      }

    },
    getCity(){
      this.options.city = []
      this.input_data.city = ""
      if(this.input_data.state !== null){
        let payload = {state_id:this.input_data.state}
        AxiosCall.Get(payload, urlApi.city.combo).then(res=>{
          if(res.success){
            this.options.city = res.atributes
            if(this.data !== null){
              let found = this.options.city.some(el=>el.id==this.data.city)
              this.input_data.city = (found ? this.data.city:"")
            }
          }else{
            this.$parent.errorMessage(res.message)
          }
        }).catch(e=>{
          this.$parent.errorMessage(e.response.data.message)
        })
      }
    },
    getSubDistrict(){
      this.options.sub_district = []
      this.input_data.sub_district = ""
      if (this.input_data.city !== null ){
        let payload = {city_id:this.input_data.city}

        AxiosCall.Get(payload, urlApi.city.sub_district.combo).then(res=>{
          if(res.success){
            this.options.sub_district = res.atributes
            if (this.data !== null){
              let found = this.options.sub_district.some(el=>el.id===this.data.sub_district)
              this.input_data.sub_district = (found ? this.data.sub_district :"")
            }
          }else {
            this.$parent.errorMessage(res.message)
          }
        }).catch(e=>{
          this.$parent.errorMessage(e.response.data.message)
        })
      }
    },
    checkForm(){
      let result = true
      if (this.input_data.country === "" ){
        result = false
      }
      return result
    }
  },
  created() {
    this.getCountry()
    this.getTypeAddress()
  }
}
</script>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>